import { render, staticRenderFns } from "./DeletePopup.vue?vue&type=template&id=2272ebca"
import script from "./DeletePopup.vue?vue&type=script&lang=ts"
export * from "./DeletePopup.vue?vue&type=script&lang=ts"
import style0 from "./DeletePopup.vue?vue&type=style&index=0&id=2272ebca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports